import React from "react";

const DAYS = [
  { id: "monday", label: "Mon" },
  { id: "tuesday", label: "Tue" },
  { id: "wednesday", label: "Wed" },
  { id: "thursday", label: "Thu" },
  { id: "friday", label: "Fri" },
  { id: "saturday", label: "Sat" },
  { id: "sunday", label: "Sun" },
];

export default function DayPills({ value = [], onChange }) {
  const selected = new Set(value.map((d) => d.toLowerCase()));

  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    onChange?.(Array.from(next));
  };

  return (
    <div className="flex flex-wrap gap-2">
      {DAYS.map((day) => {
        const active = selected.has(day.id);
        return (
          <button
            key={day.id}
            type="button"
            onClick={() => toggle(day.id)}
            className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${
              active
                ? "bg-blue-500 text-white border-blue-500"
                : "bg-white text-gray-600 border-gray-200 hover:border-blue-300"
            }`}
          >
            {active ? "✓ " : ""}
            {day.label}
          </button>
        );
      })}
    </div>
  );
}

export { DAYS };
